import { Box, LinearProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

const COUNTDOWN_IN_SECONDS = 5

const QueryRefreshTimer = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const [secondsRemaining, setSecondsRemaining] = useState(COUNTDOWN_IN_SECONDS)
  const [progress, setProgress] = useState(100)

  const handleRefresh = () => {
    queryClient.invalidateQueries()
    setSecondsRemaining(COUNTDOWN_IN_SECONDS)
  }

  useEffect(() => {
    if (secondsRemaining > 0) {
      const timer = setTimeout(() => {
        setSecondsRemaining(secondsRemaining - 1)
        setProgress((secondsRemaining - 1) * (100 / COUNTDOWN_IN_SECONDS))
      }, 1000)
      return () => clearTimeout(timer)
    } else {
      handleRefresh()
    }
  }, [secondsRemaining])

  return (
    <Box sx={{ mb: 2 }}>
      <Typography gutterBottom>{t('pages.appointment.messages.pageRefresh', { secondsRemaining })}</Typography>
      <LinearProgress variant="determinate" value={progress} />
    </Box>
  )
}

export { QueryRefreshTimer }
